import TableList from 'components/commons/TableList/TableList.component';
import { Stack } from 'styles';
import { FraudTrackingBody } from './FraudTrackingBody.component';
import FraudTrackingHeader from './FraudTrackingHeader.component';

const FraudTrackingTable = () => {
	return (
		<Stack width={'100%'} height={`calc(100vh - 280px)`} overflow={'hidden'}>
			<TableList header={<FraudTrackingHeader />} body={<FraudTrackingBody />} />
		</Stack>
	);
};

export default FraudTrackingTable;
